import { DateInput, GroupBox, Labeled } from '@infotech-soe/erp-ui-kit';
import React, { memo, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { DatasetColumnFormat } from '../../../../../services/dataset/view-model/DatasetGridColumn';

import { messages } from './messages';
import PresenceValueCheckboxes from './PresenceValueCheckboxes';
import { InputConditionsProps, InputName, InternalTypes } from './types';

const DateConditions = ({
  column: { domain, format },
  condition: { value },
  onChange,
}: InputConditionsProps<Date | boolean>): React.JSX.Element => {
  const { formatMessage } = useIntl();

  const truncTo = useMemo(() => {
    const type = domain.values ? InternalTypes.ENUM : format;
    return type === DatasetColumnFormat.DATE_TIME_SEC ? 'sec' : 'day';
  }, [domain.values, format]);

  return (
    <GroupBox label={formatMessage(messages.condition)}>
      <GroupBox.Content className="row m-mt-md">
        <PresenceValueCheckboxes value={value} onChange={onChange} />
        <div className="row col-12">
          <Labeled className="col-6" label={formatMessage(messages.startDate)}>
            <DateInput
              disabled={value.empty || value.notEmpty}
              format={domain.format}
              name={InputName.BEFORE}
              truncTo={truncTo}
              value={value.before ? new Date(value.before) : ''}
              onChange={(v: Date | null) => onChange(v, InputName.BEFORE)}
            />
          </Labeled>
          <Labeled className="col-6" label={formatMessage(messages.endDate)}>
            <DateInput
              disabled={value.empty || value.notEmpty}
              format={domain.format}
              name={InputName.AFTER}
              truncTo={truncTo}
              value={value.after ? new Date(value.after) : ''}
              onChange={(v: Date | null) => onChange(v, InputName.AFTER)}
            />
          </Labeled>
        </div>
      </GroupBox.Content>
    </GroupBox>
  );
};

export default memo(DateConditions);
